import { mutateApi } from "src/utils/api/ApiMethods"

export const updateGeneralSettings = ({ marinaSlug, data }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/settings/update_general_settings`,
    method: "POST",
    data,
  })
}
